import { t } from '@lingui/macro';
import {
  TNotification,
  TNotificationSubscription,
} from 'lendingApi/notifications';

function formatDate(dateStr: string, i18n: any): string {
  const today = new Date();
  const notificationDate = new Date(dateStr);

  today.setHours(0, 0, 0, 0);
  notificationDate.setHours(0, 0, 0, 0);

  const timeDiff = today.getTime() - notificationDate.getTime();
  const daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

  if (daysDiff === 0) return t`Today`;
  if (daysDiff === 1) return t`Yesterday`;

  return i18n.date(notificationDate, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

export function groupNotificationsByDays(
  notifications: TNotification[],
  i18n: any,
): { date: string; notifications: TNotification[] }[] {
  const dateNotificationsMap = notifications.reduce(
    (acc: Record<string, TNotification[]>, notification) => {
      const formattedDate = formatDate(notification.created, i18n);
      (acc[formattedDate] = acc[formattedDate] || []).push(notification);
      return acc;
    },
    {},
  );

  return Object.entries(dateNotificationsMap).map(([date, notifications]) => ({
    date,
    notifications,
  }));
}

export function hasFilters(subscriptions?: TNotificationSubscription[]) {
  if (!subscriptions) return false;

  return Boolean(subscriptions.find((item) => !item.subscribed));
}
